import { Mail, Phone, MapPin } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function Footer() {
  const { setOpen } = useCart();
  return (
    <footer className="bg-ink text-cream pt-20 pb-10 noise-overlay overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid md:grid-cols-[1.4fr_1fr_1fr] gap-12 border-b border-white/10 pb-14">
          <div>
            <div className="flex items-center gap-2">
              <img
                src="https://customer-assets-lqy194kg.emergentagent.net/job_party-gear-rent/artifacts/1atmdulj_Logo%20Fiestas%20Moderno%20Simple%20en%20Negro%20y%20Rosa%20%282%29.png"
                alt="Cornerstone Celebrations"
                className="h-20 w-auto object-contain"
              />
            </div>
            <p className="mt-5 font-display font-700 italic text-lg text-brand-yellow" data-testid="footer-slogan">
              The Foundation of Every Great Celebration.
            </p>
            <p className="mt-3 text-cream/60 font-500 max-w-sm">
              Your local party rental crew. Bouncy houses, tents, tables and everything
              in between — delivered, set up, and stress-free.
            </p>
            <button
              onClick={() => setOpen(true)}
              className="mt-6 rounded-full bg-brand-coral text-white px-6 py-3 font-700 hover:-translate-y-1 transition-transform"
              data-testid="footer-book-btn"
            >
              Start Your Booking
            </button>
          </div>

          <div>
            <h4 className="font-display font-800 text-lg mb-4">Contact</h4>
            <ul className="space-y-3 text-cream/70 font-500">
              <li className="flex items-center gap-2"><Phone size={16} className="text-brand-yellow" /> (555) 018-2273</li>
              <li className="flex items-center gap-2"><Mail size={16} className="text-brand-yellow" /> Bookings@CornerstoneCelebrations.com</li>
              <li className="flex items-center gap-2"><MapPin size={16} className="text-brand-yellow" /> Serving the greater Charlotte area</li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-800 text-lg mb-4">Hours</h4>
            <ul className="space-y-2 text-cream/70 font-500">
              <li>Mon – Fri · 8am – 7pm</li>
              <li>Sat – Sun · 7am – 9pm</li>
              <li className="text-brand-green font-700">Same-day setup available</li>
            </ul>
          </div>
        </div>
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-3 text-cream/40 text-sm font-500">
          <span>© {new Date().getFullYear()} Cornerstone Celebrations. All rights reserved.</span>
          <span>Ephesians 2:20 · Built for unforgettable celebrations.</span>
        </div>
      </div>
    </footer>
  );
}
